<template>
    <div class="ui-search-container">
        <div class="ui-search limit-width">

            <slot name="default"></slot>

            <div class="combo-search">
                <div class="combo-search-clean">
                    <ui-input v-model="workingValue" class="search-input" type="text" :placeholder="placeholder"
                        @keyupEnter="handleSearch" />
                    <lock-button class="clean-button" @click="workingValue = ''; handleSearch();"
                        v-if="workingValue.trim()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </lock-button>
                </div>
                <lock-button class="search-button" @click="handleSearch" :disabled="!workingValue.trim()">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </lock-button>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'UiSearch',
    props: {
        placeholder: {
            type: String,
            default: 'Search...'
        },
        value: {
            type: String,
            default: ''
        }
    },
    emits: ['update:value', 'search'],
    data() {
        return {
            workingValue: ''
        }
    },
    watch: {
        value(newValue) {
            this.workingValue = newValue
        }
    },
    methods: {
        handleSearch() {
            this.$emit('input', this.workingValue.trim());
            this.$emit('search', this.workingValue.trim());
        }
    },
    beforeMount() {
        this.workingValue = this.value;
    }
}
</script>

<style lang="less">
.ui-search {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;

    &-container {
        background-color: var(--primary-transparent);
        border-bottom: var(--border-style);
        padding: 0.5em;
    }

    .search-button {
        flex-shrink: 0;
        .lock-button{
            box-shadow: inherit;
            background-clip: padding-box;
            border: 1px solid #ced4da !important;
            border-radius: 0.25rem;
            border-bottom: 0 !important;
            box-shadow: none;
            padding: 9px 12px;
            &:disabled {
                /* opacity: 0.5; */
                opacity: 1;
            }
        }
    }

    .combo-search {
        display: flex;
        gap: 8px;
        align-items: center;

        .combo-search-clean {
            flex: 1;
            position: relative;

            .search-input {
                width: 100%;

                &.ui-input {
                    padding: 0 !important;
                    margin: 0 !important;
                    input {
                        padding-right: 2.5em !important;
                    }
                }
            }

            .clean-button {
                position: absolute;

                // TOP
                right: 0;
                bottom: -0.25em;

                .lock-button.shadow-3d-small.main-btn.bg-primary {
                    background-color: var(--primary-transparent);

                    &:not(:hover) {
                        background: none;
                    }

                    height: 100%;
                    box-shadow: none;
                }

                .lock-button {
                    background-color: transparent !important;
                    color: var(--dimmed);

                    &:hover {
                        background-color: transparent !important;
                        color: var(--danger);
                    }
                }
            }
        }
    }

    .button-holder {
        margin: 0 !important;
        padding: 0 !important;
    }

    input {
        border-radius: 0.5em;
        border-bottom: none !important;
        text-transform: uppercase;
        font-weight: bolder !important;
    }

    @media screen and (max-width: 480px) {
        flex-flow: column;
        align-content: baseline;

        .combo-search {
            width: 80vw;
        }
    }
}
</style>